/**
 * Use MSAL
 */
const useMsal = true;

/**
 * Use Azure APIs or local
 */
const useAzureApi = true;

/**
 * Use OKTA
 */
const useOkta = false;

/**
 * OKTA Domain
 */
const oktaDomain = '';

/**
 * OKTA Client ID
 */
const oktaClientId = '';

/**
 * OKTA redirect
 */
const oktaRedirectUri = '';

/**
 * OKTA post-logot redirect
 */
const oktaPostLogoutRedirectUri = '';

//ISPINIT AAD
/**
 * Tenant ID
 */
const tenantId = 'bd6b7994-eef3-4013-87c1-5bfff2fe29a0';//ISPINIT AAD

/**
 * Client ID
 */
const clientId = '0be5b263-7b94-4d50-8643-a55cbc310f7e';//StreamUKAadApp

/**
 * Azure authority
 */
const azureAuthority = `https://login.microsoftonline.com/${tenantId}`;

/**
 * Azure authority domain
 */
const azureAuthorityDomain = `https://login.microsoftonline.com/${tenantId}`;

/**
 * Azure scopes
 */
const azureScopes = [`${clientId}/.default`, 'openid', 'profile'];

/**
 * Protected resource maps - these APIs need authentication
 */
const azureProtectedResourceMap: Map<string, Array<string>> = new Map([
  ['https://ispinitstreamuk-polluxapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluximportapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxcomparablesapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxprojectvaluationapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxsettingsapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxreportdesignerapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxprojectmainapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxdatatransformationapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxdataverseapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxargusintegrationapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxpixintegrationapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxpixwintegrationcapforceapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxcurrenciesapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxcasemanagementapi-we.azurewebsites.net', azureScopes],
  ['https://ispinitstreamuk-polluxpixwintegrationvaloremapi-we.azurewebsites.net', azureScopes]
]);

/**
 * Azure redirect
 */
const azureRedirectUri = 'https://ispinitstreamuk-ui-we.azurewebsites.net';

/**
 * Azure post-logout redirect
 */
const azurePostLogoutRedirectUri = '';

if ((useMsal || useOkta) && !useAzureApi) {
  azureProtectedResourceMap.set('http://localhost/PolluxValuation_L3', azureScopes);
}

/**
 * The environment
 */
export const environment = {
  /* localhost - local APIs (set also "Azure: false")*/
  defaultLocale: 'en-US',
  production: true,
  UseMsal: useMsal,
  importAsync: false,
  reportPublishEnabled: true,
  textWidgetTrustHtml: true,
  showProcessTemplateSettings: true,
  dataverseReadOnlyMode: false,
  disableDynamicWidgets: false,

  POLLUX_API_URL:  'https://ispinitstreamuk-polluxapi-we.azurewebsites.net/api/v2',
  POLLUX_IMPORT_API_URL:  'https://ispinitstreamuk-polluximportapi-we.azurewebsites.net/api/v2',
  POLLUX_COMPARABLES_API_URL: 'https://ispinitstreamuk-polluxcomparablesapi-we.azurewebsites.net/api/v2',
  POLLUX_PROJECTVALUATION_API_URL: 'https://ispinitstreamuk-polluxprojectvaluationapi-we.azurewebsites.net/api/v2',
  POLLUX_SETTINGS_API_URL: 'https://ispinitstreamuk-polluxsettingsapi-we.azurewebsites.net/api/v2',
  POLLUX_REPORTDESIGNER_API_URL: 'https://ispinitstreamuk-polluxreportdesignerapi-we.azurewebsites.net/api/v2',
  POLLUX_MAIN_API_URL: 'https://ispinitstreamuk-polluxprojectmainapi-we.azurewebsites.net',
  POLLUX_DATAVERSE_API_URL: 'https://ispinitstreamuk-polluxdataverseapi-we.azurewebsites.net/api/v2',
  POLLUX_ARGUS_INTEGRATION_API_URL: 'https://ispinitstreamuk-polluxargusintegrationapi-we.azurewebsites.net/api/v2',
  POLLUX_PIX_INTEGRATION_API_URL: 'https://ispinitstreamuk-polluxpixintegrationapi-we.azurewebsites.net/api/v2',
  POLLUX_PIXW_INTEGRATION_CAPFORCE_API_URL: 'https://ispinitstreamuk-polluxpixwintegrationcapforceapi-we.azurewebsites.net/api/v2',
  POLLUX_CURRENCIES_API_URL: 'https://ispinitstreamuk-polluxcurrenciesapi-we.azurewebsites.net/api/v2',
  POLLUX_CASE_MANAGEMENT_API_URL: 'https://ispinitstreamuk-polluxcasemanagementapi-we.azurewebsites.net/api/v2',
  POLLUX_PIXW_INTEGRATION_VALOREM_API_URL: 'https://ispinitstreamuk-polluxpixwintegrationvaloremapi-we.azurewebsites.net/api/v2',

  /* AZURE */
  DASHBOARD_WIDGET_DOCUMENTATION_GUID: '84E91AB1-5DA2-42A3-8FF1-FC551FC91C64',

  /* AZURE */
  AzureTenentId: tenantId,
  AzureClientId: clientId,
  AzureAuthority: azureAuthority,
  AzureAuthorityDomain: azureAuthorityDomain,
  AzureScopes: azureScopes,
  AzureRedirectUri: azureRedirectUri,
  AzurePostLogoutRedirectUri: azurePostLogoutRedirectUri,
  AzureProtectedResourceMap: azureProtectedResourceMap,
  /*COMMON*/
  GOOGLE_MAPS_API_URL: 'https://maps.google.com/maps/api/js?v=3&key=AIzaSyCEAvh-RyDaU-9ctZLznQYdUpmt86TFQ0E',
  GoogleApiKey: 'AIzaSyCEAvh-RyDaU-9ctZLznQYdUpmt86TFQ0E',

  /*OKTA*/
  UseOkta: useOkta,
  OktaDomain: oktaDomain,
  OktaClientId: oktaClientId,
  OktaRedirectUri: oktaRedirectUri,
  OktaPostLogoutRedirectUri: oktaPostLogoutRedirectUri,

  /* Import */
  leadMappingVersionId: 7,

  /* PIX INTEGRATION*/
  PIX_SEARCH_ROOT_API_URL: 'https://pixsearch-qa.jll.com/pixSearch/',

  /* Pendo */
  PendoScriptOrigin: 'https://cdn.pendo.io',
  PendoApiKey: '',//to enable Pendo set to 59a403e0-e207-415f-46ac-5e13cba27759 (iSpinit key)
  PendoAccountId: 'PIX-DEV-WE',

  /* FullStory */
  FullStoryScript: 'edge.fullstory.com/s/fs.js',
  FullStoryHost: 'fullstory.com',
  FullStoryOrgId: '',//to enable Fullstory set to o-1JPFAA-na1 (iSpinit OrgId)

  /* From AppConfig.json */
  serverPath: "https://ispinitstreamuk-polluxapi-we.azurewebsites.net/",
  serverBasePath: "https://ispinitstreamuk-polluxapi-we.azurewebsites.net/",
  serverBasePathNonPrint: "https://ispinitstreamuk-polluxapi-we.azurewebsites.net/",
  polluxApiUrl: "https://ispinitstreamuk-polluxapi-we.azurewebsites.net",
  polluxImportApiUrl: "https://ispinitstreamuk-polluximportapi-we.azurewebsites.net",
  reportDesignerApiUrl: "https://ispinitstreamuk-polluxreportdesignerapi-we.azurewebsites.net",
  comparablesApiUrl: "https://ispinitstreamuk-polluxcomparablesapi-we.azurewebsites.net",
  projectValuationApiUrl: "https://ispinitstreamuk-polluxprojectvaluationapi-we.azurewebsites.net",
  settingsApiUrl: "https://ispinitstreamuk-polluxsettingsapi-we.azurewebsites.net",
  dataTransformationApiUrl: "https://ispinitstreamuk-polluxdatatransformationapi-we.azurewebsites.net",
  dataverseApiUrl: "https://ispinitstreamuk-polluxdataverseapi-we.azurewebsites.net",
  argusIntegrationApiUrl: "https://ispinitstreamuk-polluxargusintegrationapi-we.azurewebsites.net",
  pixIntegrationApiUrl: "https://ispinitstreamuk-polluxpixintegrationapi-we.azurewebsites.net",
  pixWIntegrationCapforceApiUrl: "https://ispinitstreamuk-polluxpixwintegrationcapforceapi-we.azurewebsites.net",
  currenciesApiUrl: "https://ispinitstreamuk-polluxcurrenciesapi-we.azurewebsites.net",
  caseManagementApiUrl: "https://ispinitstreamuk-polluxcasemanagementapi-we.azurewebsites.net",
  pixWIntegrationValoremApiUrl: "https://ispinitstreamuk-polluxpixwintegrationvaloremapi-we.azurewebsites.net"
};
